import React, {useContext} from "react";
import HelpComponent from "components/HelpComponent";
import FormTranslationContext from "context/FormTranslationContext";
import DateTimePicker from "components/DateTimePicker";

function NoticeDateTimeInput
({
     id,
     formikProps,
     className,
     required
 }) {
    const {formTr, formTip} = useContext(FormTranslationContext)
    const tip = formTip(id);


    const input = <DateTimePicker
        className={className}
        formikProps={formikProps}
        id={id}
        label={formTr(id)}
        required={required}
        skipCheckTouched
    />

    if (tip)
        return <HelpComponent text={tip}>
            {input}
        </HelpComponent>
    return input;


}

export default NoticeDateTimeInput;